
export enum ChartHeaderElementsEnum {
    TITLE = 'title',
    DATE = 'date',
    SOURCE = 'source',
}

export class ChartDisplaySettingsModel {
    title: boolean;
    dateRange: boolean;
    sourceLink: boolean;
    previousPeriod: boolean;
    multiSource: boolean;
    trendIndicators: boolean;
    entityProfile: boolean;
    dateFormat: string;
    displaySourceAsLink: boolean;

    constructor(apiModel?: any) {
        if (apiModel) {
            this.title = apiModel.title ?? true;
            this.dateRange = apiModel.dateRange ?? true;
            this.sourceLink = apiModel.sourceLink ?? true;
            this.previousPeriod = apiModel.previousPeriod ?? false;
            this.multiSource = apiModel.multiSource ?? false;
            // backward compatibility: if previousPeriod is false, trendIndicators should be false as well
            if (apiModel.previousPeriod === false) {
                this.trendIndicators = false;
            } else {
                this.trendIndicators = apiModel.trendIndicators || false;
            }
            this.entityProfile = apiModel.entityProfile || false;
            this.displaySourceAsLink = apiModel.displaySourceAsLink ?? true;
        } else {
            this.title = true;
            this.dateRange = true;
            this.sourceLink = true;
            this.previousPeriod = false;
            this.multiSource = false;
            this.trendIndicators = false;
            this.entityProfile = false;
            this.displaySourceAsLink = true;
        }
    }

    public hasSourceLink(): boolean {
        return this.multiSource ? true : this.sourceLink;
    }

    public hasAllElements(): boolean {
        return this.title && this.dateRange && (this.multiSource ? true : this.sourceLink);
    }

    public hasNoElements(): boolean {
        return !this.title && !this.dateRange && (this.multiSource ? true : !this.sourceLink);
    }

    public isEqual(other: ChartDisplaySettingsModel) {
        if (this.title !== other.title) {
            return false;
        }
        if (this.dateRange !== other.dateRange) {
            return false;
        }
        if (this.sourceLink !== other.sourceLink) {
            return false;
        }
        if (this.multiSource !== other.multiSource) {
            return false;
        }
        if (this.previousPeriod !== other.previousPeriod) {
            return false;
        }
        if (this.trendIndicators !== other.trendIndicators) {
            return false;
        }
        if (this.entityProfile !== other.entityProfile) {
            return false;
        }
        if (this.displaySourceAsLink !== other.displaySourceAsLink) {
            return false;
        }
        return true;
    }
}

